import { render, staticRenderFns } from "./TheBookTourIcon.vue?vue&type=template&id=580d9dd6&"
import script from "./TheBookTourIcon.vue?vue&type=script&lang=js&"
export * from "./TheBookTourIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports